import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import Instagram from "@mui/icons-material/Instagram";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { baseURL, getCategoryList, GetHVPGetCategoryList } from "../../../networkCalls";

const promise = GetHVPGetCategoryList();
const HIFotterMain = () => {
  const [catlist, setCatlist] = React.useState();
  useEffect(() => {
    promise.then((res) => {
      setCatlist(res?.data.categoryList);
    });
  }, [catlist]);

  return (
    <>
      <div className=" bghivalueplus hifooterpadd site-footer">
        <div className="container">
          <div className="row pt-lg-5 pb-lg-4">
            <div className="col-lg-4 col-md-6 col-12 mb-2">
              <div className="row">
                <div className="col-12">
                  <h3 className="text-white f18  mb-3">Contact Us</h3>
                </div>
              </div>
              <div className="row f13">
                <div className="col-12">
                  <p className="text-white">
                    <span className="text-white">Telephone:</span> 0120-2590100
                  </p>
                  <p className="text-white">
                    <span className="text-white">Toll Free:</span> 1800-11-2323
                    <br />
                    {/* <span className="text-white">Grievance Officier:</span>{" "}
                    <a
                      className=" text-white"
                      href="mailto:customer.support@hipp.co.in"
                    >
                      customer.support@hipp.co.in{" "}
                    </a>
                    <br /> */}
                    <span className="text-white">Email (Sales):</span>{" "}
                    <a
                      className=" text-white"
                      href="mailto:ho.mktg@hipp.co.in"
                    >
                      ho.mktg@hipp.co.in
                    </a>
                    <br />
                    <span className="text-white">Email (Service):</span>{" "}
                    <a
                      className=" text-white"
                      href="mailto:ho.service@hipp.co.in"
                    >
                      ho.service@hipp.co.in
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-md-6 col-12 mb-2 ">
              <div className="row">
                <div className="col-12 col-lg-8">
                  <h3 className="text-white f18 mb-3">Company</h3>
                  <ul className="flinkmenu ">
                    <li>
                      <Link to="/about-us">About Us</Link>
                    </li>
                    <li>
                      <Link to="/contact-us">Contact Us</Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">Privacy Policy</Link>
                    </li>
                    {/* <li>
                      <Link to="/return-refund-policy">
                        Return & Refund Policy
                      </Link>
                    </li> */}
                    <li>
                      <Link to="/terms-of-use">Terms and Conditions</Link>
                    </li>
                  </ul>
                </div>
                <div className="col-12 col-lg-4">
                  <h3 className="text-white f18  mb-3">Category</h3>
                  <ul className="flinkmenu">
                    {catlist &&
                      catlist?.length > 0 &&
                      catlist?.map((data, i) => (
                        <li key={i}>
                          <a href={`#`}>
                            {data?.name}
                          </a>
                        </li>
                      ))}


                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-12 mb-2 text-start text-lg-end">

              <div className="row f13">
                <div className="col-12">
                  <p className="text-white  mb-1">
                    Follow us on social networks
                  </p>
                  <div>
                    <a
                      href="https://www.facebook.com/hondaindiapowerproductslimited/"
                      target="_blank"
                      className="text-white"
                    >
                      <FacebookIcon />
                    </a>
                    <a
                      href="https://www.youtube.com/channel/UCw5zgVa0o9sqcwZxI8axfHw/"
                      target="_blank"
                      className="text-white ms-2"
                    >
                      <YouTubeIcon />
                    </a>
                    <a
                      href="https://www.linkedin.com/company/honda-india-power-products-ltd/"
                      target="_blank"
                      className="text-white ms-2"
                    >
                      <LinkedInIcon />
                    </a>
                    <a
                      href="https://www.instagram.com/hondaindiapowerproducts/"
                      target="_blank"
                      className="text-white ms-2"
                    >
                      <Instagram />
                    </a>
                  </div>
                </div>
              </div>
              {/* <div className="d-flex align-items-center gap-2  f13 mt-2">
                <a
                  href="https://play.google.com/store/apps/details?id=com.hipp.hondapower&pli=1"
                  alt=""
                  target="_blank"
                  className=""
                >
                  <img
                    src={`${baseURL}images/googleplaylogo.svg`}
                    width={"150"}
                  />
                </a>
                <a
                  href=" https://apps.apple.com/in/app/honda-power/id6749749640"
                  alt=""
                  target="_blank"
                  className=""
                >
                  <img src={`${baseURL}images/iosappicon.svg`} width={"150"} />
                </a>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <div className="hifooterdisclaimer text-white copyright_wrap">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center f15 py-2 d-flex align-items-center gap-2 me-5 pe-5">
              <div className="fw-semibold">Disclaimer: </div>
              <marquee
                scrollamount="5"
                onmouseover="this.stop();"
                onmouseout="this.start();"
              >
                <p className="mb-0">
                  Informing customers that Honda is not responsible for transactions or dealings between customers and dealers, serving only as a connecting platform.

                </p>
              </marquee>
            </div>
          </div>
        </div>
      </div>
      <div className="hivaluebgFooter text-white copyright_wrap">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center copyrighttext fw-medium pt-lg-4 pb-lg-4">
              Copyright @ Honda India Power Products Ltd. (Formerly Honda Siel
              Power Products Ltd.), {new Date().getFullYear()}, All Rights Reserved.
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default React.memo(HIFotterMain);
